import ContainerPainel from 'components/container_painel';
import { StepperHorizontal } from 'components/shared/stepper_horizontal';
import React, { useEffect, useState } from 'react';
import useEditTermAdhesion from './use_edit_term_adhesion';
import Step1 from './step1';
import Step2 from './step2';
import { useParams, useNavigate } from 'react-router-dom';
import { getAgreementTermById } from 'api/agreement-term/agreement-term.api';
import { CircularProgress } from '@mui/material';
import { usePermissions, ModuleEnum, PermissionType } from 'contexts/auth/permission_context';
import { ROUTES } from 'routes/constants';

export type FormDataType = {
  dadosTermosAdesao: {
    uuid: string;
    prefeitura: string;
    prefeituraNome: string;
    dataAssinatura: string;
    status: boolean;
  };
  anexoArquivo: {
    fileUuid: string | null;
    name: string;
    type: string;
    size: number;
    base64: string;
  } | null;
};

const EditTermOfAdhesion: React.FC = () => {
  const { activeStep, handleNext, handleBack } = useEditTermAdhesion();
  const steps = ['Dados principais', 'Confirmação dos Dados'];
  const [formData, setFormData] = useState<FormDataType | null>(null);

  const { uuid } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasPermission(ModuleEnum.ADHESION_TERM, PermissionType.UPDATE)) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }
  }, []);

  const getTerm = async () => {
    const response: any = await getAgreementTermById(uuid!);
    console.log('response', response);
    const responseFormData = {
      dadosTermosAdesao: {
        uuid: response?.uuid,
        prefeitura: response?.institution?.name,
        prefeituraUuid: response?.institution?.uuid,
        prefeituraNome: response?.institution?.name,
        dataAssinatura: response?.signatureAt,
        status: response?.status,
      },
      anexoArquivo: {
        fileUuid: response?.file?.uuid,
        name: response?.file?.name,
        type: response?.file?.mimeType,
        size: response?.file?.size,
        base64: response?.file?.base64,
      },
    };
    console.log('responseFormData', responseFormData);
    setFormData(responseFormData);
    setIsLoading(false);
  };

  useEffect(() => {
    getTerm();
  }, []);

  if (!formData) return null;

  return (
    <ContainerPainel pagina='Editar Termos de Adesão Municipal' showBackButton>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <StepperHorizontal activeStep={activeStep} steps={steps} />
          {activeStep === 0 && (
            <Step1
              formData={formData}
              setFormData={setFormData}
              onNext={() => handleNext()}
            />
          )}
          {activeStep === 1 && (
            <Step2 formData={formData} onBack={handleBack} />
          )}
        </>
      )}
    </ContainerPainel>
  );
};

export default EditTermOfAdhesion;
